import { useContext, useMemo } from 'react';
import CurrentUserContext from '../CurrentUserContext';

export const useAuthorization = () => {
  const { user, isLoading } = useContext(CurrentUserContext);
  const auth = useMemo(
    () => ({
      isLoading,
      can: action => {
        if (!user) {
          return false;
        }

        switch (action) {
          case 'manage_users':
          case 'assign_restricted_action_categories':
          case 'change_assets':
            return user?.admin;
          default:
            return false;
        }
      }
    }),
    [isLoading, user]
  );

  return auth;
};
